import { useMemo } from 'react';
import useSWR from 'swr';

import { Grid } from '@mui/material';
import { ILenderListItem } from '@modules/admin/Tools/shared/LenderControlsHeader';
import { SERVICES } from '@shared/constants/apiConfig';
import { NumberInputField } from '@shared/fields/NumberInputField';
import { FormPart } from '@modules/shared/components/FormPart';
import { getOptions } from '@shared/commonFunctions';
import { CancelButton, SaveButton } from '@shared/inputs/Buttons';
import { CommonButtonWrapper, PageContent } from '@styles/CommonStyles';
import { SelectAutocompleteField } from '@shared/fields/SelectAutocompleteField';
import { IOverrideFormProps } from './types';

export const OverrideForm = ({ handleClose, values, setFieldValue, isLoading }: IOverrideFormProps) => {
  const { data: lendersFetched = [], isValidating } = useSWR<ILenderListItem[]>(`${SERVICES.LENDER}/lenders`);

  const lenders = useMemo(
    () =>
      lendersFetched?.filter((lender) => lender.code)?.sort((a: ILenderListItem, b: ILenderListItem) =>
        a.name.toUpperCase().localeCompare(b.name.toUpperCase()),
      ),
    [lendersFetched],
  );

  const formConfig = [
    {
      hideNoneOption: true,
      width: '50%',
      name: 'lenderCode',
      label: 'Selected lender',
      options: getOptions(lenders, 'code', 'name'),
      isLoading: isValidating,
      shouldUpdate: () => true,
      component: SelectAutocompleteField,
      onChange: (value: string) => setFieldValue?.('lenderId', value),
    },
    {
      width: '25%',
      name: 'rate',
      label: 'Rate',
      value: values?.rate,
      component: NumberInputField,
      decimalScale: 2,
      limit: 8,
    },
    {
      width: '25%',
      name: 'term',
      label: 'Term',
      value: values?.term,
      limit: 3,
      component: NumberInputField,
    },
  ];

  return (
    <>
      <PageContent>
        <Grid container spacing={12}>
          <Grid item md={12}>
            <FormPart config={formConfig} />
          </Grid>
        </Grid>
      </PageContent>

      <CommonButtonWrapper>
        <CancelButton onClick={handleClose} />
        <SaveButton isLoading={isLoading} />
      </CommonButtonWrapper>
    </>
  );
};
